<template>
	<form @submit.prevent="updateTag()" class="mb-5">
		<h1 class="text-dark">Edit Tag</h1>
		<div class="row">
			<div class="form-group col-sm-6 mb-4">
				<BaseInput
					name="tagName"
					label="Tag Name"
					type="text"
					v-model="tag.name"
					class="form-control form-control-lg dashInput"
					rules="required|min:3|max:50"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="col-lg-6"></div>
			<div class="form-group col-sm-6 mt-2 mb-4">
				<BaseButton
					class="btn btn-primary form-control"
					type="submit"
					label="Create"
					:disabled="formState.disable"
					:loading="formState.isLoading"
				/>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive, inject } from "vue";
	import { useRouter } from "vue-router";
	import API from "@/config/api";
	import BaseInput from "@/components/BaseInput";
	import BaseButton from "@/components/BaseButton";
	import toast from "@/config/toast";

	export default {
		name: "TagEdit",
		components: {
			BaseInput,
			BaseButton,
		},

		setup: (props, { emit }) => {
			const store = inject("store");
			const masterStore = inject("masterStore");

			const router = useRouter();
			const tag = reactive({
				name: null,
			});

			const formState = reactive({
				isLoading: false,
				disable: true,
			});

			const validation = reactive({
				invalid: [],
				valid: [],
				nullable: [],
			});

			if (!store.state.auth.isAuth) router.push({ name: "Login" });
			if (!masterStore.state.data?.name || !masterStore.state.editId)
				masterStore.methods.changeComponent("table");
			tag.name = masterStore.state.data?.name;

			const updateTag = async () => {
				try {
					const response = await API.privateRequest.patch(
						`tags/${masterStore.state.editId}`,
						tag,
					);

					toast.success("Tag Updated!");
					masterStore.methods.setId("edit", null);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			//? checking conditions to enable or disable form login button
			const checkForm = () => {
				let inValLength = validation.invalid.length;

				if (inValLength) {
					formState.disable = true;
				} else formState.disable = false;
			};

			//? adding and removing form fields from valid and invalid state
			const setFormVal = (data) => {
				if (validation.invalid.length) {
					const newInvalid = validation.invalid.filter(
						(error) => error.field !== data.field,
					);
					validation.invalid = newInvalid;
				}
				if (validation.valid.length) {
					const newValid = validation.valid.filter(
						(item) => item.field !== data.field,
					);
					validation.valid = newValid;
				}
				return;
			};

			// event handler for valError event
			const valError = (data) => {
				setFormVal(data);
				validation.invalid = [...validation.invalid, data];
				checkForm();
			};

			const valSuccess = (data) => {
				setFormVal(data);
				validation.valid = [...validation.valid, data];
				checkForm();
			};

			return {
				tag,
				updateTag,
				valError,
				valSuccess,
				formState,
			};
		},
	};
</script>
